/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Staff extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
};
export default Staff;


// WEBPACK FOOTER //
// ./src/routes/staff/index.js